// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBVD_v-kHng1SizxEO4ZF3FecgLbhiUr8o",
    authDomain: "anonymous-systems-dev.firebaseapp.com",
    databaseURL: "https://anonymous-systems-dev-default-rtdb.firebaseio.com",
    projectId: "anonymous-systems-dev",
    storageBucket: "anonymous-systems-dev.appspot.com",
    messagingSenderId: "160347575398",
    appId: "1:160347575398:web:a29a7b932649cae54749a7",
    measurementId: "G-ZXCJBFNDCG"
  },
  vapidKey: 'BDVZby-VXgCi4yk31wAhkkEHAblgD5zOIUJiu1sq-RzMwHn-pwBVefWNSYMe-nNz2F0JKDygm6PqKW15nsAU3AI',
  recaptcha3SiteKey: '6LeEV7shAAAAAA1Fs_bc2EjoLMOKhVjs6b7pKhaL',
  appVersion: require('../../package.json').version
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
